import { useAuthContext } from '@aibees/shared/auth';
import {
  Nullable,
  PaginationRequest,
  PaginationResponse,
  ParsedPreset,
  PresetVisibility,
} from '@aibees/shared/definition';
import { QueryOptions } from '@aibees/shared/http';
import { useBaseQuery } from '@aibees/shared/http/hooks';
import { jsonParseSafe, stableHash } from '@aibees/shared/utils';
import { useWorkspace } from '@aibees/shared/workspace';
import { useCallback } from 'react';
import { PRESET_API_PREFIX } from './constants';

type BrowsePresetRequest = PaginationRequest<{
  type: string | string[];
  name?: string | null;
  visibility?: Nullable<PresetVisibility>;
  favorite?: boolean;
}>;

export function useBrowsePresetApi<T = unknown>(
  params: BrowsePresetRequest,
  options?: QueryOptions
) {
  const workspace = useWorkspace()?.id;
  const { user } = useAuthContext();
  params.page ||= 0;
  params.size ||= 5;
  params.name ||= undefined;
  const { type, name, ...filters } = params;
  const filtersKey = stableHash(filters);

  const userId = user?.id;

  const select = useCallback(
    (data: PaginationResponse<ParsedPreset<T>>) => ({
      ...data,
      content: data.content.map((x) => ({
        ...x,
        isMine: x.workspace.user.id === userId,
        value: jsonParseSafe(x.value, {}) as T,
      })),
    }),
    [userId]
  );

  return useBaseQuery<
    BrowsePresetRequest,
    PaginationResponse<ParsedPreset<T>>,
    PaginationResponse<ParsedPreset<T>>
  >(
    [useBrowsePresetApi.name, type, name, filtersKey],
    {
      url: PRESET_API_PREFIX.replace(':id', String(workspace)),
      params,
    },
    {
      ...options,
      select,
    }
  );

  /* const result: UseQueryResult<
    PaginationResponse<ParsedPreset<T>>,
    ErrorResponse
  > = {
    ...(api as any),
    currentPlan: api.data as PaginationResponse<ParsedPreset<T>>,
  };
  return result; */
}
